<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <p class="whitespace-pre-wrap text-card-foreground" v-html="processedText"></p>
</template>

<script setup lang="ts">
const props = defineProps<{
  text: string
}>()

const processedText = computed(() => {
  if (!props.text) return ''
  const urlPattern = /(https?:\/\/[^\s]+)/g
  return props.text.replace(urlPattern, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Link</a>`
  })
})
</script>
